/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import '../App.css';
import React, { useEffect, useMemo, useState } from 'react';
import twitter from '../assets/twitter-.png';
import facebook from '../assets/facebook.png';
import instagram from '../assets/instagram.png';
import whatsapp from '../assets/whatsapp.png';
import navbar from '../assets/navigation-bar.png';
import wrong from '../assets/wrong.png';
import logoPic from '../assets/logo.jpg';
import ticket from '../assets/movie.png';
import money from '../assets/money.png';
import Footer from '../components/footer';
import line3 from '../assets/line3.jpg';
import money2 from '../assets/1710350929.jpeg';
import user from '../assets/profile-user (2).png';
import pol from '../assets/polygon.png';
import ticketT from '../assets/ticket (2).png';
import calander from '../assets/calendar.png';
import location from '../assets/placeholder.png';
import ticket2 from '../assets/ticket.png';
import coupon from '../assets/coupon.png';
import back from '../assets/previous.png'
import correct from '../assets/check-mark.png';
import warning from '../assets/warning.png';
import coin from '../assets/coin.png';
import refund from '../assets/refund.png';

import $ from 'jquery';
import { Web3Button, Web3Modal, useWeb3Modal } from '@web3modal/react';
import { mainnet, useAccount, useContractRead, useContractReads, useContractWrite, useNetwork, usePublicClient, useSwitchNetwork } from 'wagmi';
import { createPublicClient, formatEther, http, parseEther } from 'viem';
import { pulsechainV4 } from 'wagmi/chains';
import { useLocation, useNavigate } from 'react-router-dom';

import contractRaffle from '../contractData/contractRaffle.json';
import contractToken from '../contractData/contractToken.json';
import { ethers } from 'ethers';
import ReportedRaffles from '../components/reportedIds';

var Scroll = require('react-scroll');

$(window).on('load', function () {
	setTimeout(function () { // allowing 3 secs to fade out loader
		$('.page-loader').fadeOut('slow');
	}, 2000);
});

const renderer = ({ days, hours, minutes, seconds, completed }) => {
	/*	if (completed) {
			// Render a completed state
			return <Completionist />;
		} else {*/
	// Render a countdowns

	if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {

		window.location.reload(true);
		console.log("Mint Begins");
	}


	return <div class="counterBlock"><div class="days">{days}</div><div class="dots">:</div><div class="days">{hours}</div><div class="dots">:</div><div class="days">{minutes}</div><div class="dots">:</div><div class="sec">{seconds}</div></div>;
	/*	}*/
};

let signer;
var Link = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;


const tweet = () => {
	window.open("#");
}

const discord = () => {
	window.open("#");
}

const os = () => {
	window.open("#");
}

const address = contractRaffle.address;
const ABI = contractRaffle.abi;

const addressToken = contractToken.address;
const ABIToken = contractToken.abi;


const RafflePage = () => {

	const { open } = useWeb3Modal()
	const { chain } = useNetwork()
	const { switchNetwork } = useSwitchNetwork()
	const { state } = useLocation();
	const navigate = useNavigate();
	//const raffle = state?.raffle;
	const [userDetails, setUserDetails] = useState([]);
	const [quantity, setQuantity] = useState(1); // Default quantity is 1

	const [statusError, setStatusError] = useState("")
	const [showOwnerBuy, setShowOwnerBuy] = useState("")	
	const [statusLoading, setStatusLoading] = useState("")
	const [success, setSuccess] = useState("")
	const [limitReached, setLimitReached] = useState("")
	const [showErrorDiv, setShowErrorDiv] = useState(false);
	const [_ErrorMsg1, setErrorMsg1] = useState("");
	const [_reported, setReported] = useState("");
	const [_claimed, setClaimed] = useState("");
	const [_reportedAlready, setReportedAlready] = useState("");
	const [txnHash, setTxnHash] = useState("");
	const [_topBuyers, setTopBuyers] = useState("");
	const [showNotRegistered, setShowNotRegistered] = useState("")
	const [raffles, setRaffles] = useState([]);
	//const [expectedValue, setExpectedValue] = useState({});
	const [expectedValue, setExpectedValue] = useState("0");
	const [winner, setWinner] = useState(null);
	const [isRaffleEnded, setIsRaffleEnded] = useState(false);
	const [isWinnerDrawn, setIsWinnerDrawn] = useState(false);
	const [isCreator, setIsCreator] = useState(false);
	const [isFetchingWinner, setIsFetchingWinner] = useState(false);
	const [winnerDrawnSuccess, setWinnerDrawnSuccess] = useState(false);
	const [winnerDrawnSuccessLoading, setWinnerDrawnLoading] = useState(false);
	const [_progress, setProgress] = useState(0);
	const [_totalTicketsIssued, set_totalTicketsIssued] = useState(0);
	const [_totalTicketsValue, set_totalTicketsValue] = useState(0);
	const [_expectedTotal, setExpectedTotal] = useState(0);
	const [_myReports, set_myReports] = useState(0);
	const [hasReported, setHasReported] = useState(false);
	const [reportedRaffles, setReportedRaffles] = useState([]);
	const [raffle, setRaffle] = useState(state?.raffle);

	const [timeLeft, setTimeLeft] = useState({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0
	});


	const handleBack = () => {
		navigate('/raffles');
	};

	const { address: walletAddress } = useAccount({
		async onConnect() {
			handleConnect()
		}
	})

	const publicClient = createPublicClient({
		chain: pulsechainV4,
		transport: http()
	})

	const [_navbarOpen, set_navbarOpen] = useState(0)
	const [_connected, setConnected] = useState(false)


	async function myReports() {
		set_myReports(1);
	}

	async function navbarOpen() {
		set_navbarOpen(1);
	}

	const contract = {
		address: address,
		abi: ABI
	}

	const contracToken = {
		address: addressToken,
		abi: ABIToken
	}

	async function handleConnect() {
		if (chain.id !== 943) {
			switchNetwork(943)
		}

		setConnected(true);
	}

	const { data: userData, refetch: fetchUserDetails } = useContractRead({
		...contract,
		functionName: 'registeredUsers',
		args: [raffle?.creator]
	});

	const { refetch: getTopBuyers } = useContractRead({
		...contract,
		functionName: 'getTopBuyers',
		args: [raffle?.id]
	})

	useEffect(() => {
		if (userData) {
			try {
				// Handle different possible data formats
				let details = [];

				if (Array.isArray(userData)) {
					// If data is already an array
					details = userData.map(item => item.toString());
				} else if (typeof userData === 'string') {
					// If data is a comma-separated string
					details = userData.split(',');
				} else {
					// Fallback for other formats
					details = [userData.toString()];
				}
				console.log("raffle.id : " + raffle.id);
				setUserDetails(details);
			} catch (error) {
				setUserDetails(['Unknown', 'Unknown location']);
			}
		}

		async function fetchTopBuyers() {
			try {
				const { data } = await getTopBuyers();
				if (data) {
					// The smart contract returns [names, counts, values]
					const buyerNames = data[0] || [];
					const ticketCounts = data[1] || [];
					const totalValues = data[2] || [];

					// Combine into an array of buyer objects
					const buyersData = buyerNames.map((name, index) => ({
						name: name,
						ticketCount: ticketCounts[index]?.toString() || "0",
						totalValue: totalValues[index]?.toString() || "0"
					}));

					// Sort by highest ticket count (descending)
					buyersData.sort((a, b) => b.ticketCount - a.ticketCount);

					// Take top 5 buyers
					const top5Buyers = buyersData.slice(0, 5);

					setTopBuyers(top5Buyers);
				}
			} catch (error) {
				console.error("Error fetching top buyers:", error);
			}
		}

		fetchTopBuyers();

	}, [userData, getTopBuyers]);

	// FIXED VERSION:
	useEffect(() => {
		const calculateTimeLeft = () => {
			try {
				const endTimeMs = Number(raffle.endTime) * 1000;
				const now = Date.now();
				const difference = endTimeMs - now;

				console.log("endTimeMs : " + endTimeMs);
				console.log("difference : " + difference);

				if (difference > 0) {
					setTimeLeft({
						days: Math.floor(difference / (1000 * 60 * 60 * 24)),
						hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
						minutes: Math.floor((difference / 1000 / 60) % 60),
						seconds: Math.floor((difference / 1000) % 60)
					});
					setIsRaffleEnded(false);
					console.log("isRaffleEnded_1 : " + isRaffleEnded);
				} else {
					setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
					setIsRaffleEnded(true);
					console.log("isRaffleEnded_2 : " + isRaffleEnded);
				}
			} catch (error) {
				console.error("Error calculating time left:", error);
			}
		};

		calculateTimeLeft();
		const timer = setInterval(calculateTimeLeft, 1000);

		return () => clearInterval(timer);
	}, [raffle?.endTime]); // Now depends on raffle.endTime instead of state?.raffle.endTime

	const { data: winnerData, refetch: fetchWinner } = useContractRead({
		address: address,
		abi: ABI,
		functionName: 'getRaffleWinner',
		args: [raffle.id],
		enabled: false // We'll trigger this manually
	});

	// Add a useEffect to check if the winner is drawn when the raffle has ended
	useEffect(() => {
		if (isRaffleEnded && raffle?.id) {
			const fetchWinnerData = async () => {
				setIsFetchingWinner(true);
				try {
					const { data } = await fetchWinner();
					if (data && data[0] !== '0x0000000000000000000000000000000000000000') {
						setWinner({
							address: data[0],
							name: data[1],
							ticketIndex: data[2]
						});
						setIsWinnerDrawn(true);
					}
				} catch (error) {
					console.error("Error fetching winner:", error);
				} finally {
					setIsFetchingWinner(false);
				}
			};
			fetchWinnerData();
		}
	}, [isRaffleEnded, raffle?.id, fetchWinner]);

	// Format time to always show 2 digits
	const formatTime = (num) => num.toString().padStart(2, '0');


	const { writeAsync } = useContractWrite({
		...contract,
		functionName: 'mint',
		onError(error) {
			if (error.message.includes('balance')) {
				setstatusError(true)
				setstatusLoading(false)
			}
		}
	})

	const handleIncrease = () => {
		setQuantity(prevQuantity => prevQuantity + 1);
	};

	const handleDecrease = () => {
		if (quantity > 1) {
			setQuantity(prevQuantity => prevQuantity - 1); // Ensure quantity doesn't go below 1
		}
	};

	const { refetch: raffleRead } = useContractRead({
		...contract,
		functionName: 'raffles',
		args: [raffle.id]
	})

	/*
	async function fetchRafflesData() {
		const value = await raffleRead();

		set_totalTicketsIssued(Number(value.data[7]));
		set_totalTicketsValue(Number(value.data[8]));

		console.log("full raffle response " + value.data);

		console.log('Value of the tickets Issued : ' + Number(value.data[8]));


		const exvalue = await fetchExpectedValue(raffle.id);

		console.log("Maximum tickets" + exvalue);

		console.log("total Tickets Issued - after buy" + Number(value.data[7]));

		const progress = (Number(value.data[7]) * 100) / Number(exvalue);

		console.log("progress-after buy : " + progress);

		setProgress(progress);

	};
*/

	async function fetchRafflesData() {
		const { data } = await raffleRead();

		// Get expected value (keep your existing logic)
		const exvalue = await fetchExpectedValue(raffle.id);

		// Calculate progress (keep your existing logic)
		const progress = (Number(data[7]) * 100) / Number(exvalue);

		// Update all states
		set_totalTicketsIssued(Number(data[7]));
		set_totalTicketsValue(Number(data[8]));
		setProgress(progress);
		setExpectedValue(exvalue);

		// Create and return updated raffle object
		const updatedRaffle = {
			...raffle, // Keep existing properties
			totalTicketsIssued: Number(data[7]),
			totalValue: Number(data[8]),
			isStopped: data[6], // Assuming index 5 is isStopped
			endTime: data[5]     // Assuming index 4 is endTime
		};

		console.log("updatedRaffle : " + updatedRaffle.endTime);
		console.log("isStopped : " + updatedRaffle.isStopped);

		return updatedRaffle;
	}

	const handleBuyTicket = async () => {
		try {
			setStatusLoading(true);
			const ticketPriceInEther = raffle.ticketPrice;
			const totalPriceInEther = (parseFloat(ticketPriceInEther) * quantity).toString();

			const res = await writeAsync({
				...contract,
				functionName: 'buyTicket',
				args: [raffle.id, quantity],
				value: parseEther((totalPriceInEther / 10 ** 18).toString()),
				gas: 2100000,
				gasPrice: 160000000000
			});

			const txnHash = res.hash;
			setTxnHash(txnHash);

			await new Promise((resolve) => setTimeout(resolve, 3000));

			const result = await publicClient.waitForTransactionReceipt(res);

			if (result.status === "success") {
				// Get the updated raffle data
				const updatedRaffle = await fetchRafflesData();

				// Update the raffle state
				setRaffle(updatedRaffle); // You'll need to add this state

				setStatusError(false);
				setSuccess(true);
				setStatusLoading(false);
			} else {
				setSuccess(false);
				setStatusError(true);
				setStatusLoading(false);
			}
		} catch (e) {
			console.error("Transaction failed:", e);
			if (e.message.includes("Transaction with hash")) {
				console.log("adkiuyhsalofdjalkhfjdalskhf");
			}
			if (e.message.includes("err: insufficient funds for gas")) {
				setErrorMsg1("Insufficient funds");
				setShowErrorDiv(true); // Show the error div for insufficient funds
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			} else if (e.message.includes("User rejected the request")) {
				setErrorMsg1("User Rejected");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			}
			else if (e.message.includes("User not registered")) {
				setErrorMsg1("User not registered");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
				setShowNotRegistered(true);
			}
			else if (e.message.includes("Raffle creator cannot buy tickets")) {
				setErrorMsg1("User not registered");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
 				setShowOwnerBuy(true);
			}
			else if (e.message.includes("Already claimed refund")) {
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
				setShowNotRegistered(false);
				setLimitReached(true);
			}
			else {
				setErrorMsg1("Sorry, something went wrong");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);

				setStatusError(true);
				setStatusLoading(false);
			}

		}
	};

	const reportRaffle = async () => {
		try {
			setStatusLoading(true);

			const res = await writeAsync({
				...contract,
				functionName: 'reportRaffle',
				args: [raffle.id],
				gas: 2100000,
				gasPrice: 160000000000
			});

			const txnHash = res.hash;
			setTxnHash(txnHash);
			console.log("Transaction hash:", txnHash);

			await new Promise((resolve) => setTimeout(resolve, 3000));

			// Wait for transaction receipt
			const result = await publicClient.waitForTransactionReceipt(res);

			console.log("Transaction result:", result);

			if (result.status === "success") {
				setStatusError(false);
				setReported(true);
				setStatusLoading(false);

				fetchRafflesData();
			} else if (result.status) {
				setReported(false);
				setStatusError(true);
				setStatusLoading(false);
			}
		} catch (e) {
			console.error("Transaction failed:", e);
			if (e.message.includes("Transaction with hash")) {
				console.log("adkiuyhsalofdjalkhfjdalskhf");
			}
			if (e.message.includes("err: insufficient funds for gas")) {
				setErrorMsg1("Insufficient funds");
				setShowErrorDiv(true);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			} else if (e.message.includes("User rejected the request")) {
				setErrorMsg1("User Rejected");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			}
			else if (e.message.includes("User not registered")) {
				setErrorMsg1("User not registered");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
				setShowNotRegistered(true);
			}
			else if (e.message.includes("Already reported")) {  // Added specific error handling for this case
				setErrorMsg1("You've already reported this raffle");
				setReportedAlready(true);
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			}
			else {
				setErrorMsg1("Sorry, something went wrong");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(true);
				setStatusLoading(false);
				setReported(false);
			}
		}
	};

	async function closNotifications() {
		setShowErrorDiv(false);
		setStatusError(false);
		setShowNotRegistered(false);
		setLimitReached(false);
		setReportedAlready(null);
	}

	async function closeNotificationsSuccess() {
		setSuccess(false);
		setReported(null);
	}

	const fetchExpectedValue = async (raffleId) => {
		try {
			const value = await publicClient.readContract({
				address: address,
				abi: ABI,
				functionName: 'expectedTotalValue',
				args: [raffleId]
			});
			return value.toString();
		} catch (err) {
			console.error("Error fetching expected value:", err);
			return "0"; // Default value if there's an error
		}
	};

	useEffect(() => {
		if (raffle?.id) {
			const loadExpectedValue = async () => {
				const value = await fetchExpectedValue(raffle.id);
				setExpectedValue(value);
				console.log("expected value : " + value);
			};
			loadExpectedValue();
		}

		fetchRafflesData();

	}, [raffle?.id]);


	const formatAddress = (address) => {
		if (!address) return '';
		return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
	};

	useEffect(() => {
		if (walletAddress && raffle?.creator) {
			setIsCreator(walletAddress.toLowerCase() === raffle.creator.toLowerCase());
		}

		// Safely calculate progress
		const expectedTotal = Number(raffle.ticketPrice) * Number(expectedValue);
		if (expectedTotal > 0) { // Only calculate if denominator is not zero
			const progress = (Number(raffle.totalValue) * 100) / expectedTotal;
			setProgress(progress);
			setExpectedTotal(expectedTotal);
		} else {
			setProgress(0); // Set to 0 if no tickets expected
		}



	}, [walletAddress, raffle?.creator, raffle?.totalValue, raffle?.ticketPrice, expectedValue]);

	const { writeAsync: drawWinner, isLoading: isDrawingWinner } = useContractWrite({
		address: contract.address,
		abi: contract.abi,
		functionName: 'drawWinner', // Make sure this matches your contract function exactly
	});

	const handleDrawWinner = async () => {
		try {
			setWinnerDrawnLoading(true);

			const result = await drawWinner({
				args: [raffle.id]
			});

			// Wait for transaction to be mined
			const receipt = await publicClient.waitForTransactionReceipt({
				hash: result.hash
			});

			if (receipt.status === "success") {
				setWinnerDrawnLoading(false);
				setWinnerDrawnSuccess(true);
				// Refresh winner data
				const { data } = await fetchWinner();
				if (data && data[0] !== '0x0000000000000000000000000000000000000000') {
					setWinner({
						address: data[0],
						name: data[1],
						ticketIndex: data[2]
					});
					setIsWinnerDrawn(true);
				}
			}
		} catch (error) {
			console.error("Error drawing winner:", error);
			setWinnerDrawnLoading(false);
			setWinnerDrawnSuccess(false);
			setStatusError(true);
		}
	};

	const { data: reportStatus } = useContractRead({
		...contract,
		functionName: 'reportedRaffles',
		args: [raffle.id, walletAddress],
		watch: true, // This will refresh after state changes
	});

	useEffect(() => {
		if (reportStatus) {
			setHasReported(reportStatus);
		}
	}, [reportStatus]);

	const [refundEligibility, setRefundEligibility] = useState({
		eligible: false,
		refundAmount: 0,
		alreadyRefunded: false,
		isWinner: false
	});

	const { refetch: checkRefund } = useContractRead({
		address: address,
		abi: ABI,
		functionName: 'checkRefundEligibility',
		args: [walletAddress, raffle?.id],
		enabled: false // We'll trigger this manually
	});

	const fetchRefundEligibility = async () => {
		if (walletAddress && raffle?.id) {
			const { data } = await checkRefund();
			if (data) {
				setRefundEligibility({
					eligible: data[0],
					refundAmount: data[1],
					alreadyRefunded: data[2],
					isWinner: data[3]
				});
			}
		}
	};

	const handleClaimRefund = async () => {
		try {
			setStatusLoading(true);

			const res = await writeAsync({
				...contract,
				functionName: 'claimRefund',
				args: [raffle.id],
				gas: 2100000,
				gasPrice: 160000000000
			});

			const txnHash = res.hash;
			setTxnHash(txnHash);
			console.log("Transaction hash:", txnHash);

			await new Promise((resolve) => setTimeout(resolve, 3000));

			// Wait for transaction receipt
			const result = await publicClient.waitForTransactionReceipt(res);

			console.log("Transaction result:", result);

			if (result.status === "success") {
				setStatusError(false);
				setClaimed(true);
				setStatusLoading(false);

				fetchRafflesData();
			} else if (result.status) {
				setClaimed(false);
				setStatusError(true);
				setStatusLoading(false);
			}
		} catch (e) {
			console.error("Transaction failed:", e);
			if (e.message.includes("Transaction with hash")) {
				console.log("adkiuyhsalofdjalkhfjdalskhf");
			}
			if (e.message.includes("err: insufficient funds for gas")) {
				setErrorMsg1("Insufficient funds");
				setShowErrorDiv(true);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			} else if (e.message.includes("User rejected the request")) {
				setErrorMsg1("User Rejected");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			}
			else if (e.message.includes("User not registered")) {
				setErrorMsg1("User not registered");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
				setShowNotRegistered(true);
			}
			else {
				setErrorMsg1("Sorry, something went wrong");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(true);
				setStatusLoading(false);
				setClaimed(false);
			}
		}
	};

	useEffect(() => {
		fetchRefundEligibility();
	}, [walletAddress, raffle?.id]);

	async function closeClaim() {
		setClaimed(false);
		window.location.reload(true);
	}

	return (
		<div class="allWrap">
			<div class="light">
				<div className='back' onClick={handleBack} ><img src={back} />Back to list</div>
				<div className="popup-content2">
					<div className='picAndDetails'>
						<img className='detailslPic' src={raffle?.imageUrl || money2} />
						<div className='mainR2'>
							<div className='section1'>
								<div className='s1H'>{raffle?.name || 'One Million MXN Pesos'}</div>
								<div className='s1Sub'>Price per ticket</div>
								<div className='amountR'>{raffle?.ticketPrice / 10 ** 18 || '50.00'}<img src={coin} /></div>

								<div className='description'>{raffle?.tagline || 'Win a million pesos for only fifty pesos a ticket'}</div>
							</div>

							<div className='lineDash'></div>

							<div className='section2'>
								<div className='s2H'><img src={coupon} />Details</div>
								<div className='flexDetails'>
									<div className='leftS'>Total up to now </div>
									<div className='rightS'>Expected up to now</div>
								</div>

								<div className='flexDetails'>
									<div className='leftS'>{_totalTicketsValue / 10 ** 18} <img src={coin} /></div>
									<div className='rightS'>{(raffle.ticketPrice) * (Number(expectedValue)) / 10 ** 18} <img src={coin} /></div>
								</div>

							</div>

							<div>
								<div className="progress-container">
									<div className="progress-label">
										Progress: {isFinite(_progress) ? _progress.toFixed(2) : 0}%
									</div>
									<div className="progress-bar-background">
										<div
											className="progress-bar-fill"
											style={{ width: `${Math.min(isFinite(_progress) ? _progress : 0, 100)}%` }}
										></div>
									</div>
								</div>
								<div className='note'>Note: A minimum of 80% of tickets sold is required to hold this raffle.</div>
							</div>
						</div>
					</div>

					<div className='userMain'>
						<div className='userDetails'>
							<div className='s2H'><img src={coupon} />Raffle Information</div>
							<div className='user'><img src={user} />{userDetails[0] || 'Loading...'}</div>

							{isRaffleEnded ? (
								raffle.totalTicketsIssued >= (expectedValue * 80) / 100 ? (
									isFetchingWinner ? (
										<div className='winnerSection'>
											<div className='endDate'>🏆 Drawing Winner...</div>
											<div className='winnerDetail'>Please wait while we determine the winner</div>
										</div>
									) : isWinnerDrawn ? (
										<div className='winnerSection'>
											<div className='endDate'>🏆 Winner Announcement</div>
											<div className='winnerDetail'>
												<strong>Name:</strong> {winner?.name || 'Anonymous'}
											</div>
											<div className='winnerDetail'>
												<strong>Wallet Address:</strong>
												<a
													href={`https://scan.v4.testnet.pulsechain.com/#/address/${winner?.address}`}
													target="_blank"
													rel="noopener noreferrer"
													className="wallet-link"
												>
													{formatAddress(winner?.address)}
												</a>
											</div>
											<div className='winnerDetail'>
												<strong>Winning Ticket:</strong> #{Number(winner?.ticketIndex)}
											</div>

											{isWinnerDrawn && winner?.address?.toLowerCase() === walletAddress?.toLowerCase() && (
												<div className="winner-notice-2">
													🌟 Congratulations! You've won the raffle!
												</div>
											)}
										</div>
									) : (
										<div className='winnerSection'>
											<div className='endDate'>🏆 Winner Announcement</div>
											{isCreator ? (
												<button
													onClick={handleDrawWinner}
													className="draw-winner-btn"
													disabled={isDrawingWinner}
												>
													{isDrawingWinner ? 'Drawing...' : 'Draw Winner'}
												</button>
											) : (
												<div className='winnerDetail waiting'>
													Time has ended. Winner will be announced soon!
												</div>
											)}
										</div>
									)
								) : (
									<>
										<div className="endDate">
											<span id='cancel'>🚫 Raffle canceled. Expected Threshold could not be achieved.</span>
										</div>

										<div className="refund-section">
											<div className="refund-header">
												<img src={refund} alt="Refund icon" />
												<h3>Refund</h3>
											</div>

											{refundEligibility.eligible && !refundEligibility.alreadyRefunded && !refundEligibility.isWinner ? (
												<div className="refund-content">
													<div className="refund-amount">
														<span>Refund available:</span>
														<strong>{formatEther(refundEligibility.refundAmount)} POL</strong>
													</div>
													<button
														onClick={handleClaimRefund}
														className="refund-btn"
													>
														<span>Claim Refund</span>
													</button>
												</div>
											) : refundEligibility.alreadyRefunded ? (
												<div className="refund-success">
													You've successfully claimed your refund for this raffle.
												</div>
											) : refundEligibility.isWinner ? (
												<div className="refund-notice">
													Winners are not eligible for refunds.
												</div>
											) : (
												<div className="refund-notice">
													You're not currently eligible for a refund.
												</div>
											)}
										</div>
									</>
								)
							) : (
								<div>
									<div className='endDate'>End Date <img src={calander} /></div>
									<div className='timer'>
										{timeLeft.days === 0 && timeLeft.hours === 0 &&
											timeLeft.minutes === 0 && timeLeft.seconds === 0 ? (
											<div id='ended'>Raffle has ended</div>
										) : (
											<>
												<div>
													<div id="days">{timeLeft.days}</div>
													<span>days</span>
												</div>
												<div>
													<div id="hours">{formatTime(timeLeft.hours)}</div>
													<span>hours</span>
												</div>
												<div>
													<div id="minutes">{formatTime(timeLeft.minutes)}</div>
													<span>minutes</span>
												</div>
												<div>
													<div id="seconds">{formatTime(timeLeft.seconds)}</div>
													<span>seconds</span>
												</div>
											</>
										)}
									</div>
								</div>
							)}

							<div className='location'>
								<div className='endDate'>Prize Location <img src={location} /></div>
								<div className='city'>{userDetails[1] || 'Location not specified'}</div>
							</div>
						</div>

						<div className='userTicket'>
							<div className='s2H'><img src={coupon} />Top of tickets purchased</div>
							<div className='ticketDetailsMain'>
								{_topBuyers.length > 0 ? (
									_topBuyers.map((buyer, index) => (
										<div className='ticketDetails' key={index}>
											<img src={ticket2} alt="Ticket icon" />
											<div className="buyer-info">
												<div><img id='iconData' src={user} /> {buyer.name || "Anonymous"}</div>
												<div><img id='iconData' src={ticketT} /> {buyer.ticketCount} tickets</div>
												<div><img id='iconData' src={pol} />{(Number(buyer.totalValue) / 10 ** 18).toFixed(2)} POL</div>
											</div>
										</div>
									))
								) : (
									<div className='no-buyers'>No buyers yet</div>
								)}
							</div>
						</div>
					</div>


					<div className='note2Main'>

						<div className='buyTicketMobile'>

							{raffle.totalTicketsIssued < expectedValue ?
								<div className='buyTicketMobile'>

									<div className='counter'>
										<span className='decrease' onClick={handleDecrease}>-</span>
										{quantity}
										<span className='increase' onClick={handleIncrease}>+</span>
									</div>
									{timeLeft.days === 0 && timeLeft.hours === 0 &&
										timeLeft.minutes === 0 && timeLeft.seconds === 0 ? (
										<button disabled>Buy Tickets <span className='fullCost'>({(raffle.ticketPrice * quantity) / 10 ** 18} POL)</span></button>) :
										(<button onClick={handleBuyTicket}>Buy Tickets <span className='fullCost'>({(raffle.ticketPrice * quantity) / 10 ** 18} POL)</span></button>)
									}
								</div> :

								<div className='buyTicketMobile'>

									<button id="lR" disabled>Ticket Limit Reached</button>

								</div>
							}
							{(Number(expectedValue)) - _totalTicketsIssued > 0 && (
								<div className='remaining'>Remaining {(Number(expectedValue)) - _totalTicketsIssued} Tickets</div>
							)}
						</div>


						<div className='s2H'><img src={coupon} />Report Raffle</div>

						<div className='note2'>

							<div>
								<div className='noteC'>Note: You can report this raffle if it has inappropriate content and/or sensitive information for some users.</div>
								<div className='report'>
									{hasReported ? (
										<button disabled>Reported</button>
									) : (
										<button onClick={reportRaffle}>Report the Raffle</button>
									)}
								</div>
								<div className='reports' onClick={myReports}>My Reported Raffles</div>
							</div>


							<div className='buyTicketMain'>

								{raffle.totalTicketsIssued < expectedValue ?
									<div className='buyTicket'>

										<div className='counter'>
											<span className='decrease' onClick={handleDecrease}>-</span>
											{quantity}
											<span className='increase' onClick={handleIncrease}>+</span>
										</div>
										{timeLeft.days === 0 && timeLeft.hours === 0 &&
											timeLeft.minutes === 0 && timeLeft.seconds === 0 ? (
											<button disabled>Buy Tickets <span className='fullCost'>({(raffle.ticketPrice * quantity) / 10 ** 18} POL)</span></button>) :
											(<button onClick={handleBuyTicket}>Buy Tickets <span className='fullCost'>({(raffle.ticketPrice * quantity) / 10 ** 18} POL)</span></button>)
										}
									</div> :

									<div className='buyTicket'>

										<button disabled>Ticket Limit Reached</button>

									</div>
								}
								{(Number(expectedValue)) - _totalTicketsIssued > 0 && (
									<div className='remaining'>Remaining {(Number(expectedValue)) - _totalTicketsIssued} Tickets</div>
								)}
							</div>


						</div>
					</div>
					{_myReports > 0 ?
						<ReportedRaffles /> :
						null}
				</div>


			</div >
			<img className='line2' src={line3} />

			{success ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={() => closeNotificationsSuccess(false)}>✖</div>

						<img className='correct' src={correct} />
						<div className='notificationHMsg'>Purchased {quantity} Tickets</div>
					</div>

				</div> : null}

			{_reported ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={() => closeNotificationsSuccess(false)}>✖</div>

						<img className='correct' src={correct} />
						<div className='notificationHMsg'>Raffle Reported Successfully</div>
					</div>

				</div> : null}

			{_claimed ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closeClaim}>✖</div>

						<img className='correct' src={correct} />
						<div className='notificationHMsg'>Refunded Successfully</div>
					</div>

				</div> : null}

			{statusError ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closNotifications}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>Sorry Something went wrong</div>
						<div className='notificationH2' id="error">Please try again</div>
					</div>
				</div> : null}

			{statusLoading ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div class="loader"></div>
						<div className='notificationHMsg'>Loading</div>
					</div>
				</div> : null}

			{showErrorDiv ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closNotifications}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>Insufficent Funds</div>
						<div className='notificationH2' id="error2">Please fill your wallet</div>
					</div>
				</div> : null}

			{showNotRegistered ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closNotifications}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>User Not Registered</div>
						<div className='notificationH2' id="error2">Please register with your wallet</div>
					</div>
				</div> : null}


			{_reportedAlready ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closNotifications}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>Already reported</div>
						<div className='notificationH2' id="error2">You’ve already reported this raffle</div>
					</div>
				</div> : null}

			{limitReached ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closNotifications}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>Already claimed refund</div>
						<div className='notificationH2' id="error2">You’ve alreadt claimed the refund</div>
					</div>
				</div> : null}

				{showOwnerBuy ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={() => setShowOwnerBuy(false)}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>Raffle creator cannot buy tickets</div>
 					</div>
				</div> : null}

			{winnerDrawnSuccess && (
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={() => setWinnerDrawnSuccess(false)}>✖</div>
						<img className='correct' src={correct} />
						<div className='notificationHMsg'>Winner Drawn Successfully!</div>
					</div>
				</div>
			)}

			{winnerDrawnSuccessLoading && (
				<div className="popup-overlay2">
					<div className="popup-container">
						<div class="loader"></div>
						<div className='notificationHMsg'>Loading</div>
					</div>
				</div>
			)}

			<Footer />

		</div >
	)

}
export default RafflePage;
